export default {
  loading: 'Removing device from organisation...',
  success: 'Removed device from organisation',
  error: 'Failed to remove device from organisation',
};
